import preact from 'preact'
import getWithInMemoryCache from '../../utils/getWithInMemoryCache'
import globals from '../../utils/globals'
import RelatedTopicsList from './RelatedTopicsList'
import { SEARCH_TOKEN_URL } from '../../libs/config'
import { InstantSearch, Configure } from 'react-instantsearch-dom'
import algoliasearch from 'algoliasearch/lite'

class RelatedTopics extends preact.Component {
  constructor () {
    super()
    this.communityId = globals('communityId')
    this.topicId = window.inSidedData.content.topic.id
    this.topicTitle = window.inSidedData.content.topic.title
  }
  componentDidMount () {
    getWithInMemoryCache(SEARCH_TOKEN_URL, {}).then(data => this.setState({
      clientId: data['client_id'],
      token: data.token
    }))
  }
  render (props, state) {
    if (!state.clientId || !state.token) return null
    return (
      <div>
        <InstantSearch
          searchClient={algoliasearch(state.clientId, state.token)}
          indexName={this.communityId}
        >
          <Configure queryType='prefixNone'
            query={this.topicTitle}
            hitsPerPage={parseInt(props.pageSize) + 1}
            removeWordsIfNoResults='allOptional' optionalWords={this.topicTitle}
            analyticsTags={['destination', 'related']} />
          <RelatedTopicsList topicId={this.topicId} totalItemCount={props.pageSize} widgetTitle={props.widgetTitle} />
        </InstantSearch>
      </div>
    )
  }
}

export default RelatedTopics
